<ng-container>
    <div [style]="generateSkeleton()" *ngIf="loading$ | async; else content"></div>
    <ng-template #content>
        <div>
            <ng-content></ng-content>
        </div>
    </ng-template>
</ng-container>